module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img74.b174fb53.jpg";